import { CellRenderProps } from "@sinecycle/growcomponents";
import {
  TextObj,
  TextWithPopoverColumn,
  TextWithPopoverProps,
} from "./TextWithPopover";

interface TextPopoverCellProps<T> extends CellRenderProps<T, TextObj[]> {
  textProps: Omit<TextWithPopoverProps, "text">;
}

function TextPopoverCell<T>(props: TextPopoverCellProps<T>) {
    const {textProps} = props
  return <TextWithPopoverColumn {...textProps} text={props.value} />;
}

export { TextPopoverCell };
